<template>
  <div>
    <el-dialog
      :title="titleDialog"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="examine">
        <div class="examineList examineListTwo">
          <div class="examineListTwo_box">
            <p style="white-space: nowrap">发布人:</p>
            <p>{{ rowForm.name }}</p>
          </div>
          <div class="examineListTwo_box">
            <p style="white-space: nowrap">发布时间:</p>
            <p>{{ rowForm.createTime }}</p>
          </div>
        </div>
        <div class="examineList examineListTwo">
          <div class="examineListTwo_box">
            <p style="white-space: nowrap">圈子名称:</p>
            <p>{{ rowForm.circleInfo==null?"":rowForm.circleInfo.circleName }}</p>
          </div>
          <div class="examineListTwo_box">
            <p style="white-space: nowrap">动态标签:</p>
            <p v-for="(items,index) in rowForm.labelList" :key="index">{{items.label}}{{rowForm.labelList.length!=(index+1)?'、':''}}</p>
          </div>
        </div>
        <div class="examineList examineListTwo">
          <div class="examineListTwo_box" style="width: 100%">
            <p style="white-space: nowrap">动态内容:</p>
            <p style="width: 80%">{{ rowForm.content }}</p>
          </div>
        </div>
        <div class="examineList examineListTwo"  v-if="rowForm.fileType == 'IMAGE'?true:false">
          <div class="examineListTwo_box examineListTwo_box_imgs">
            <p style="white-space: nowrap">图片:</p>
            <div class="fileUrl_imgs" v-if="rowForm.fileType == 'IMAGE'" >
                <el-image
                  style="width: 100px; height: 100px;margin: 0 10px 10px 0"
                  :src="item.fileUrl"
                   v-for="(item,index) in rowForm.fileList" :key="index"
                  :preview-src-list="srcList">
                </el-image>
              <!-- <img :src="item.fileUrl" alt=""/> -->
            </div>
          </div>
        </div>
          <div class="examineList examineListTwo"  v-if="rowForm.fileType == 'VIDEO'?true:false">
              <div class="examineListTwo_box examineListTwo_box_imgs">
                  <p style="white-space: nowrap">视频:</p>
                  <div class="fileUrl_imgs" v-if="rowForm.fileType == 'VIDEO'" >
                      <div class="videoBox" v-if="rowForm.fileType == 'VIDEO'">
                          <video-player  v-if="rowForm.fileType == 'VIDEO'" class="video-player vjs-custom-skin"
                                         :playsline="false"
                                         :options="playerOptions"
                          ></video-player>
                      </div>
                  </div>
              </div>
          </div>
        <div class="examineList examineListTwo">
          <div class="examineListTwo_box" v-for="(item,index) in rowForm.linkList">
            <p style="white-space: nowrap" v-show="item.dataType == 'MODEL'"> 模型 :</p>
            <a :href="$url.threeWeb + '/modelDetails?uuid=' + item.goodsUuid"  v-show="item.dataType == 'MODEL'" style="color: blue" target="_blank">{{item.title}}</a>

            <p style="white-space: nowrap" v-show="item.dataType == 'GOODS'"> 商品 :</p>
            <a :href="$url.threeWeb + '/shopGoodDetails/' + item.goodsUuid"  v-show="item.dataType == 'GOODS'" style="color: blue" target="_blank">{{item.title}}</a>

            <p style="white-space: nowrap" v-show="item.dataType == 'INFO'"> 资讯 :</p>
            <a :href="$url.threeWeb + '/news/newDetails/' + item.goodsUuid"  v-show="item.dataType == 'INFO'" style="color: blue" target="_blank">{{item.title}}</a>
          </div>
        </div>
        <div class="invoiceInformation" v-if="titleDialog == '查看'">
          <h3>审核结果</h3>
          <div class="examine">
            <el-tag
              type="warning"
              effect="dark"
              v-if="rowForm.status == 'EXAMINE'"
              >待审核</el-tag
            >
            <el-tag
              type="success"
              effect="dark"
              v-if="rowForm.status == 'PASS'"
              >审核已通过</el-tag
            >
            <el-tag
              type="danger"
              effect="dark"
              v-if="rowForm.status == 'REFUSE'"
              >审核已拒绝</el-tag
            >
            <div
              class="examineListTwo_box"
              v-if="rowForm.status == 'REFUSE'"
            >
              <p>驳回原因：</p>
              <p>{{ rowForm.remark }}</p>
            </div>
          </div>
        </div>
        <div class="audit" v-else>
          <h3>审核</h3>
          <div class="auditContent">
            <el-radio-group v-model="form.status">
              <el-radio label="PASS">通过</el-radio>
              <el-radio label="REFUSE">拒绝</el-radio>
            </el-radio-group>
            <div class="cause" v-if="form.status === 'REFUSE'">
              <div class="causeTitle">驳回原因：</div>
              <div class="causeContent" style="width: 100%">
                <el-input
                  type="textarea"
                  placeholder="请输入驳回原因"
                  v-model="form.remark"
                >
                </el-input>
              </div>
            </div>
            <div class="auditEnter">
              <el-button type="primary" @click="submit">确定</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dynamicAudit,dynamicGet } from "../../utils/interface";

export default {
  name: "dynamicDialog",
  data() {
    return {
      srcList:[],
      dialogVisible: false,
      titleDialog: "",
      labelList: {},
      form:{
        status:'',
        remark:'',
        uuid:''
      },
      rowForm:{},
      playerOptions : {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: true, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器
        sources: [{
          type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: "" //url地址
        }],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: false  //全屏按钮
        },
      },
    };
  },
  methods: {
    init(type, row) {
      this.dialogVisible = true;
      // this.rowForm = row
        dynamicGet(row.uuid).then((res)=>{
            this.rowForm =res;

            res.fileList.forEach(items => {
              this.srcList.push(items.fileUrl)
            });
            if(row.fileType =='VIDEO'){
                this.playerOptions.sources[0].src = row.fileList[0].fileUrl;
                this.playerOptions.poster = row.fileList[0].coverUrl
            }
        })

      if (type == "audit") {
        this.titleDialog = "审核";
      } else if (type == "view") {
        this.titleDialog = "查看";
      }
      this.form.uuid = row.uuid
    //   this.circleInfo = row.circleInfo;
    //   this.rowForm = row
    //   this.labelList = row.labelList;
    },
    submit() {
      if (!this.form.status) {
        this.$message.warning("请选择审核结果！");
      } else if (this.form.status === "REFUSE" && !this.form.remark) {
        this.$message.warning("请输入驳回原因！");
      } else {
        dynamicAudit(this.form.uuid,this.form.status,this.form).then((res) => {
          if (res.success === true) {
            this.$message.success("审核成功！");
            this.dialogVisible = false;
            this.$emit("fatherMethod");
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.examine {
  h2 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    margin-top: 26px;
    letter-spacing: 1px;
  }
  .examineList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    img {
      width: 200px;
      height: 200px;
    }
    .videoBox {
        width: 200px;
        margin: 0 auto;
        /deep/.vjs-custom-skin > .video-js {
            border-radius: 40px;
        }
        /deep/.video-js .vjs-tech {
            border-radius: 34px;
        }
        /deep/.vjs-custom-skin > .video-js .vjs-control-bar {
            border-radius: 0 0 34px 34px;
        }

        }
    p{
      margin-right: 16px;
      // width: 65px;
      // flex-shrink: 0;
    }
    .examine_html {
      width: 90%;
      /deep/pre {
        white-space: pre-line !important;
      }
      /deep/img {
        max-width: 100%;
      }
    }
    .examineListTwo_box {
      width: 50%;
    }
  }
  .examineListTwo {
    display: flex;
    align-items: center;
    .examineListTwo_box {
      display: flex;
      align-items: center;
      width: 50%;
    }
    .examineListTwo_box_imgs {
      align-items: flex-start;
      width: 100%;
      .fileUrl_imgs {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }
      img {
        margin-right: 10px;
        margin-bottom: 10px;
        width: 100px;
        height: 100px;
      }
    }
  }
}
.audit {
  padding-bottom: 20px;
  margin-top: 20px;
  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    margin-top: 0;
    letter-spacing: 1px;
    padding-bottom: 15px;
  }
  .cause {
    display: flex;
    margin-top: 20px;
    .causeTitle {
      min-width: 80px;
      color: #3a8ee6;
    }
    .causeContent {
      color: #000;
    }
  }
  .auditEnter {
    text-align: center;
    padding-top: 20px;
    button {
      width: 120px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dynamic/dynamicDialog.vue